import { Injectable } from '@angular/core';

import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../commons/config.service';

@Injectable()
export class TranslateService {

  private _translations: any = {};
  private _observables: any = {};

  private _timeout: any;

  constructor(
    private config: ConfigService,
    private http: Http) { }

  public getTranslations(name: string, lang: string): Observable<any> {
    let key = `${name}.${lang}`;

    // check if cached
    if (this._translations[key]) {
      return Observable.of(this._translations[key]);
    }

    // first time create observable
    if (!this._observables[key]) {
      ////console.log(`load http: ${this.config.i18nUrl}/generic.${lang}.json`);
      this._observables[key] = this.http.get(`${this.config.i18nUrl}/generic.${lang}.json`)
        .map(res => {
          ////console.log('loaded');
          this._translations[key] = res.json();
          return this._translations[key];
        })
        .concatMap(specificT => {
          ////console.log(`load http: ${this.config.i18nUrl}/${name}.${lang}.json`);
          return this.http.get(`${this.config.i18nUrl}/${name}.${lang}.json`)
            .map(res => {
              ////console.log('loaded');
              let genericT = res.json();
              return Object.assign(specificT, genericT);
            })
            .catch(err => {
              console.warn(err);
              return specificT;
            });
        })
        .catch(err => {
          // Check if almost one translations is ok
          if (this._translations[key]) {
            return Observable.of(this._translations[key]);
          }

          // cache and return empty
          let fake = { emptyResx: true };
          this._translations[key] = fake;

          if (!this._timeout) {
            console.error('error on GET resx file');
            ////console.log('create fake empty resx');

            // dopo 30s lo cancella così alla prossima richiesta riproverà
            this._timeout = setTimeout(() => {
              ////console.log('clear');
              this._translations[key] = null;
              this._timeout = null;
            }, 30000);
          }

          return Observable.of(fake);
        })
        .share();
    }

    return this._observables[key];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/translate.service.ts